import React from 'react'
import { useQuery } from '@apollo/client'

import getNearbyRestaurants from './SearchResults.graphql'
import variables from './fixtures/SearchResults.json'
import { Progress } from '@local/do-secundo-progress'
import { ErrorComponent } from '@local/do-secundo-error'

import styles from './SearchResults.module.css'

export const SearchResults = () => {
  const { loading, data, error } = useQuery(getNearbyRestaurants, {
    variables
  })
  if (loading) return <Progress />
  if (error) return <ErrorComponent error={error} />
  // We need to explicitly bypass react-router since the shortUrl is
  // part of the basename now and to ensure OO_GLOBALS gets reloaded
  // correctly.
  const restaurants = data.nearbyRestaurants.filter(({ shortUrl }) =>
    Boolean(shortUrl)
  )
  return (
    <>
      <h2>Restaurant list</h2>

      <table className={styles.table}>
        <thead>
          <tr>
            <td>Restaurant ({restaurants.length})</td>
            <td colSpan='3'>Environment</td>
          </tr>
        </thead>
        <tbody>
          {restaurants.map(({ name, shortUrl, guid }) => (
            <tr key={shortUrl}>
              <td>{name}</td>
              <td>
                <a href={`/${shortUrl}/v3`}>local dev</a>
              </td>
              <td>
                <a
                  href={`https://preprod.eng.toasttab.com/${shortUrl}/v3?overrideV3Enabled=true`}
                >
                  preprod
                </a>
              </td>
              <td>
                <a
                  href={`https://www.toasttab.com/${shortUrl}/v3?overrideV3Enabled=true`}
                >
                  prod
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  )
}
